<template>
    <v-card class="ma-4">
        <v-toolbar color="indigo" dense class="rounded rounded-b-0 mt-5">
            <v-toolbar-title class="white--text"> Turni e Fasce Orarie </v-toolbar-title>
            <v-spacer />
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn @click="addTurno" v-bind="attrs" v-on="on" small>
                        <v-icon color="primary">mdi-plus</v-icon>
                    </v-btn>
                </template>
                <span>Agg. Turno</span>
            </v-tooltip>
            <v-spacer />
        </v-toolbar>
        <v-data-table :headers="headers" fixed-header :items="items" class="elevation-1">
            <template v-slot:[`item.modifica`]="{ item }">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" small @click="addTurno(item)">
                            <v-icon color="primary">mdi-pencil</v-icon>
                        </v-btn>
                    </template>
                    <span>Modifica</span>
                </v-tooltip>
            </template>
            <template v-slot:[`item.elimina`]="{ item }">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" small @click="deleteTurnoDialog(item)">
                            <v-icon color="error">mdi-close</v-icon>
                        </v-btn>
                    </template>
                    <span>Elimina</span>
                </v-tooltip>
            </template>
        </v-data-table>

        <v-dialog v-model="dialog_add_turno" width="70%">
            <v-card>
                <v-toolbar class="indigo white--text" dense>
                    <v-toolbar-title class="white--text"> Turno </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn @click="saveTurno" v-on="on" small>
                                <v-icon color="success"> mdi-floppy </v-icon>
                            </v-btn>
                        </template>
                        <span>Salva</span>
                    </v-tooltip>
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" @click="dialog_add_turno = false" small>
                                <v-icon class="error--text"> mdi-close </v-icon>
                            </v-btn>
                        </template>
                        <span>Chiudi</span>
                    </v-tooltip>
                </v-toolbar>
                <v-container>
                    <v-row>
                        <v-col cols="6">
                            <v-text-field label="Descrizione" v-model="turno_sel.descrizione"></v-text-field>
                        </v-col>
                        <v-col cols="3">
                            <v-text-field label="Ora inizio" v-model="turno_sel.ora_inizio" type="time"></v-text-field>
                        </v-col>
                        <v-col cols="3">
                            <v-text-field label="Ora fine" v-model="turno_sel.ora_fine" type="time"></v-text-field>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialog_delete" width="50%">
            <v-card>
                <v-toolbar class="indigo white--text" dense>
                    <v-toolbar-title class="white--text"> Conferma Eliminazione </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn @click="deleteTurno" v-on="on" small>
                                <v-icon color="success"> mdi-floppy </v-icon>
                            </v-btn>
                        </template>
                        <span>Salva</span>
                    </v-tooltip>
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" @click="dialog_delete = false" small>
                                <v-icon class="error--text"> mdi-close </v-icon>
                            </v-btn>
                        </template>
                        <span>Chiudi</span>
                    </v-tooltip>
                </v-toolbar>
                <v-container>
                    <v-row class="ma-3">
                        Confermi di voler eliminare {{ turno_sel?.descrizione }}?
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>

        <!-- Snackbar -->
        <SnackbarQV ref="SnackbarQV" />

        <!-- Overlay di caricamento -->
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64" />
        </v-overlay>

    </v-card>


</template>
<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

class Turno {
    constructor(arg = undefined) {
        if (arg != undefined) {
            const campi = this.setCampi();
            campi.forEach((c) => {
                this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
            });
        } else {
            const campi = this.setCampi();
            campi.forEach((c) => {
                this[c.nome] = c.default_val;
            });
        }
    }
    // Metodo per resettare tutti i campi
    reset() {
        const campi = this.setCampi();
        campi.forEach((c) => {
            this[c.nome] = c.default_val;
        });
    }

    setCampi() {
        const campi = [
            { nome: "id_fascia_oraria", default_val: -1 },
            { nome: "descrizione", default_val: "" },
            { nome: "ora_inizio", default_val: "" },
            { nome: "ora_fine", default_val: "" },
        ];

        return campi;
    }
}

export default {
    name: "QLTurni",
    components: { SnackbarQV },
    data() {
        return {
            // Variabili d'appoggio
            turno_sel: new Turno(),
            // Modal
            dialog_add_turno: false,
            dialog_delete: false,
            overlay: false,

            //   Array
            items: [],
            headers: [
                {
                    text: "Modifica",
                    value: "modifica",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Desrcizione",
                    value: "descrizione",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Ora Inizio",
                    value: "ora_inizio",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Ora Fine",
                    value: "ora_fine",
                    filterable: false,
                    sortable: false,
                },
                {
                    text: "Elimina",
                    value: "elimina",
                    filterable: false,
                    sortable: false,
                },
            ],
        };
    },
    methods: {
        addTurno(arg) {
            if (arg) this.turno_sel = arg;
            this.dialog_add_turno = true;
        },
        getFasceOrarie() {
            const getconfig = {
                controller: "logistic",
                method: "POST",
                richiesta: {
                    token: localStorage.getItem("user_token"),
                    action: "getfasceorarie",
                },
            };
            this.overlay = true;
            this.$store.dispatch("api6", getconfig).then((res) => {
                this.overlay = false;
                if (res.status === 200 || res.status === 204) {
                    this.items = res.data.result;
                } else {
                    this.$refs.SnackbarQV.print(
                        "orange",
                        `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
                    );
                }
            })
                .catch((e) => {
                    this.overlay = false;
                    this.$refs.SnackbarQV.print("error", "Errore di comunicazione col server: " + e);
                });
        },
        saveTurno() {
            const getconfig = {
                controller: "logistic",
                method: "POST",
                richiesta: {
                    token: localStorage.getItem("user_token"),
                    action: "setfasciaoraria",
                    fascia_oraria: this.turno_sel,
                },
            };
            this.overlay = true;
            this.$store.dispatch("api", getconfig).then((res) => {
                this.overlay = false;
                if (res.status === 200 || res.status === 204) {
                    this.getFasceOrarie()
                } else {
                    this.$refs.SnackbarQV.print(
                        "orange",
                        `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
                    );
                }
            })
                .catch((e) => {
                    this.overlay = false;
                    this.$refs.SnackbarQV.print("error", "Errore di comunicazione col server: " + e);
                });
        },
        deleteTurnoDialog(arg) {
            this.dialog_delete = true;
            arg.validita = 0;
            this.turno_sel = arg;
        },
        deleteTurno() {
            const getconfig = {
                controller: "logistic",
                method: "POST",
                richiesta: {
                    token: localStorage.getItem("user_token"),
                    action: "setfasciaoraria",
                    fascia_oraria: this.turno_sel,
                },
            };
            this.overlay = true;
            this.$store.dispatch("api", getconfig).then((res) => {
                this.overlay = false;
                if (res.status === 200 || res.status === 204) {
                    this.getFasceOrarie();
                    this.dialog_delete = false;
                } else {
                    this.$refs.SnackbarQV.print(
                        "orange",
                        `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
                    );
                }
            })
                .catch((e) => {
                    this.overlay = false;
                    this.$refs.SnackbarQV.print("error", "Errore di comunicazione col server: " + e);
                });
        },
    },

    created() { },
    mounted() {
        this.getFasceOrarie();
    },
};
</script>
<style scoped></style>